import React, { useState } from "react";
import {
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaPaperPlane,
  FaClock,
} from "react-icons/fa";
import HeaderComponent from "../Header/header.component";
import FooterComponent from "../Footer/footer.component";
import "./contact-us.styles.css";

const ContactUsTemplate = ({ templateData, templateEvents }) => {
  const { formData, greet } = templateData;
  const { handleChange, handleSubmit, Message } = templateEvents;

  return (
    <div className="ds-container">
      <div className="ds-page-head text-center" style={{ maxWidth: 620, marginInline: "auto", textAlign: "center" }}>
        <p className="ds-eyebrow">We're here to help</p>
        <h1>Get in touch</h1>
        <p className="sub" style={{ marginInline: "auto" }}>
          We'd love to hear from you. Send us a message and we'll respond as soon
          as possible.
        </p>
      </div>

      <div className="ds-grid-2" style={{ gridTemplateColumns: "1.4fr 1fr", alignItems: "start", paddingBottom: 56 }}>
        <div className="ds-panel ds-panel-p">
          <h3 className="ds-mb-l">Send us a message</h3>
          <form onSubmit={handleSubmit} className="ds-stack">
            <div className="ds-field">
              <label htmlFor="name">Your Name *</label>
              <div className="ds-input">
                <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required />
              </div>
            </div>
            <div className="ds-field">
              <label htmlFor="email">Your Email *</label>
              <div className="ds-input">
                <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required />
              </div>
            </div>
            <div className="ds-field">
              <label htmlFor="subject">Subject</label>
              <div className="ds-input">
                <input type="text" id="subject" name="subject" value={formData.subject} onChange={handleChange} />
              </div>
            </div>
            <div className="ds-field">
              <label htmlFor="message">Your Message *</label>
              <textarea
                className="ds-textarea"
                id="message"
                name="message"
                rows="5"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>
            <Message
              type={greet}
              title={greet === true ? "Successfully Submitted" : "Failed"}
              text={
                greet === true
                  ? "Your information has been successfully submitted. We will contact you soon."
                  : "You have already requested twice today. We will contact you soon. Please try again tomorrow."
              }
            />
            <div>
              <button type="submit" className="ds-btn ds-btn-primary ds-btn-lg">
                <FaPaperPlane /> Send message
              </button>
            </div>
          </form>
        </div>

        <div className="ds-stack">
          <div className="ds-panel ds-panel-p">
            <p className="ds-eyebrow">Call us</p>
            <p className="ds-mono" style={{ fontWeight: 600, fontSize: 18 }}>+91 9902099933</p>
            <p className="ds-muted">Mon–Sat, 9am–7pm IST</p>
          </div>
          <div className="ds-panel ds-panel-p">
            <p className="ds-eyebrow">Email</p>
            <p style={{ fontWeight: 600 }}>order@semisearch.in</p>
            <p className="ds-muted">Quotes &amp; order support</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUsTemplate;
